import dayjs from "dayjs"
import { cloneDeep } from "lodash-es"
import React, { useMemo, useState } from "react"
import { RRule } from "rrule"
import CustomButton from "../CustomButton"
import SingleDate from "./SingleDate"
import SingleRule from "./SingleRule"
import { ruleArrayToString, ruleStringToArray } from "./utils"

export type RuleStrType = "RRULE" | "EXRULE" | "RDATE" | "EXDATE"
export type RuleType = {
  rule: RRule | Date
  type?: RuleStrType
}

type RRuleGeneratorType = {
  rule?: string
  onChange?: (rule: string) => void
  onAdd?: () => void
}
const RRuleGenerator = ({ rule, onChange, onAdd }: RRuleGeneratorType) => {
  const rules = useMemo(() => {
    return ruleStringToArray(rule)
  }, [rule])

  const [open, setOpen] = useState<null | number>(null)
  function addRule(type: "rule" | "date" = "rule") {
    const newRules = rules.concat({
      rule:
        type === "rule" ? new RRule({ freq: RRule.WEEKLY }) : dayjs().toDate(),
      type: type === "rule" ? "RRULE" : "RDATE",
    } as any)
    onChange(ruleArrayToString(newRules))
    setOpen(newRules.length - 1)
  }

  function handleOpen(index) {
    setOpen(prev => (prev === index ? null : index))
  }

  return (
    <div className="bg-white m-3 border-legacy text-sm rounded-md">
      <section>
        {rules.map((rule, index) => {
          const commonOptions = {
            isOpen: open === index,
            onDelete() {
              const newRules = rules.filter((_, i) => i !== index)
              onChange(ruleArrayToString(newRules))
            },
            index: index,
            onOpen: handleOpen,
            onTypeChange(type) {
              const rulesCopy = cloneDeep(rules)
              rulesCopy[index].type = type
              onChange(ruleArrayToString(rulesCopy))
            },
            key: index,
            ruleType: rule as any,
          }
          if (rule.type?.includes?.("DATE")) {
            return (
              <SingleDate
                onChange={rule => {
                  const rulesCopy = cloneDeep(rules)
                  rulesCopy[index].rule = rule
                  onChange(ruleArrayToString(rulesCopy))
                }}
                {...commonOptions}
              />
            )
          } else {
            return (
              <SingleRule
                onChange={rule => {
                  const rulesCopy = cloneDeep(rules)
                  rulesCopy[index].rule = rule
                  onChange(ruleArrayToString(rulesCopy))
                }}
                {...commonOptions}
              />
            )
          }
        })}
      </section>
      <footer className="p-2">
        <CustomButton
          small
          id="add-rule"
          className="mr-2"
          icon="plus"
          intent="success"
          minimal
          onClick={() => {
            onAdd?.()
            addRule("rule")
          }}
          text={"Add Rule"}
        />
        <CustomButton
          small
          id="add-date"
          icon="plus"
          intent="success"
          minimal
          onClick={() => addRule("date")}
          text={"Add Date"}
        />
      </footer>
    </div>
  )
}

export default RRuleGenerator
